import React from 'react'
import ReactDOM from 'react-dom'

interface IPortalModalProps {
  children: React.ReactNode
}

export default class PortalModal extends React.PureComponent<IPortalModalProps, null> {
  el: Element
  modalRoot: Element

  constructor(props: IPortalModalProps) {
    super(props)
    this.el = document.createElement('div')
    this.modalRoot = document.getElementById('page');
  }

  componentDidMount() {
    this.modalRoot.appendChild(this.el)
  }

  componentWillUnmount() {
    this.modalRoot.removeChild(this.el)
  }

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el)
  }
}